"use strict";
/// <reference path="irep.js" />

IREP.marathon = (function () {
    var _uid;
    var _scid;
    var _pageName = "marathon";

    var init = function (td) {
        _uid = IREP.options.user.currentUID;
        _scid = IREP.options.user.storeChainId;
        $("#Participate").click(function () { ProcessOptIn(_uid, _scid); });
        PageLoadCheck(_uid, _scid);
    };

    function TableDisplay(time) {
        $('#LeaderboardMarathon').fadeOut('slow');
        $('#textDisclaimer').fadeIn('slow');
        $('#Disclaimer').append('Тренинг Марафон завершен. Результаты будут опубликованы после проверки всех победителей!');
    }

    function PageLoadCheck(u, s) {
        var isOptedIn = false;
        IREP.callApi("/rcispromo/isoptedin", "GET", { participantUID: u, pageName: _pageName })
            .done(function (data) {
                isOptedIn = data.isOptedIn;
                if (isOptedIn == false) {
                    $('#ParticipateMarathonButton').css('display', 'block');
                    FillLeaderboard();
                } else {
                    DisplayPostOptinInfo();
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                IREP.displayError("Page Load check error: " + errorThrown);
            });
    }

    function ProcessOptIn(u, s) {
        var isOptedIn = false;
        IREP.callApi("/rcispromo/isoptedin", "GET", { participantUID: u, pageName: _pageName })
            .done(function (data) {
                isOptedIn = data.isOptedIn;
                if (isOptedIn == false) {
                    OptUserIntoContest(u, s);
                } else {
                    DisplayPostOptinInfo();
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                IREP.displayError("Optin check error: " + errorThrown);
            });
    };


    var OptUserIntoContest = function (u, s) {
        var countryCode = IREP.options.user.countryCode.toLowerCase();
        if (countryCode === "ru" || countryCode === "kz" || countryCode === "by") {

            IREP.callApi("/rcispromo/optin", "POST", { participantUID: u, storeChainId: s, pageName: _pageName })
                .done(function () {
                    DisplayPostOptinInfo();
                })
                  .fail(function (jqXHR, textStatus, errorThrown) {
                      IREP.displayError("Opt in error: " + errorThrown);
                  });
        }
    };

    var DisplayPostOptinInfo = function () {
        $("#ParticipateMarathonButton > div").remove();
        $('#ParticipateMarathonButton').css('display', 'block');
        FillLeaderboard();
    };

    var FillLeaderboard = function () {
        IREP.callApi("/rcispromo/leaderboard", "GET", { pageName: _pageName })
            .done(function (data) {
                var content = "";
                content += '<div id="baseLeaderboard"><ul class="base-row headerBaseRow"><li class="cell1 tableHeaderBd">№</li><li class="cell2 tableHeaderBd">Имя</li><li class="cell3 tableHeaderBd">Сеть</li><li class="cell4 tableHeaderBd">Город</li><li class="cell5 tableHeaderBd">Заработано баллов</li></ul><div class="listBorder"></div><br />';

                for (var i = 0, len = data.leaderboardParticipants.length; i < len; i++) {
                    var participant = data.leaderboardParticipants[i];
                    var name = participant.firstName + " " + participant.lastName.substring(0, 1) + ".";
                    var row = '<ul class="base-row">' +
                                    '<li class="cell1">' + (i + 1) + '</li>' +
                                    '<li class="cell2">' + name + '</li>' +
                                    '<li class="cell3">' + participant.chainName + '</li>' +
                                    '<li class="cell4">' + participant.city + '</li>' +
                                    '<li class="cell5">' + participant.pointsEarned + '</li>' +
                                "</ul>";
                    content += row;
                }
                content += "</div>";
                $("#LeaderboardMarathon").empty();
                $("#LeaderboardMarathon").append(content);
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                IREP.displayError("Failed to retrieve leaderboard:" + errorThrown);
                $("#LeaderboardMarathon").empty();
                $("#LeaderboardMarathon").append("test Fail");
            });
    };
    return {
        init: init
    };
})();